import { render, staticRenderFns } from "./SimulacaoResumo.vue?vue&type=template&id=6cee75cb"
import script from "./SimulacaoResumo.vue?vue&type=script&lang=js"
export * from "./SimulacaoResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports